<template>
  <div :class="classes">
    <slot />
    <picture>
      <source media="(max-width: 480px)" :srcset="imageMobile">
      <source media="(min-width: 481px) and (max-width: 1024px)" :srcset="imageTablet">
      <img :src="imageDesktop" class="c-image__item image" :alt="alt" :style="styles">
    </picture>
  </div>
</template>

<script>
  export default {
    name: 'c-image',
    props: {
      alt: {
        type: String,
        default: ''
      },
      background: {
        type: Boolean,
        default: false
      },
      imageMobile: {
        type: String,
        default: ''
      },
      imageTablet: {
        type: String,
        default: ''
      },
      imageDesktop: {
        type: String,
        default: ''
      },
      maxSize: {
        type: String,
        default: null
      }
    },
    computed: {
      classes() {
        return [
          'c-image',
          [this.background ? 'c-image--background' : 'c-image--block']
        ]
      },
      styles() {
        return {
          'max-width': `${this.maxSize}px`
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .c-image {
    $container: &;
    position: relative;
    width: 100%;
    height: auto;

    & > div {
      width: 100%;
      height: 100%;
    }

    &--block {
      #{$container}__item {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
      }
    }

    &--background {
      height: 100%;

      #{$container}__item {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
</style>


